import React, {FC, useState, useEffect} from "react"
import theme from "@irati/ui/src/global/theme"
import {Card} from "@irati/ui/src/Layout"
import {Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import topupService from "@irati/wallet/services/TopUp"

const ServiceFeeOfferCard: FC = () => {
  const [waivedTiers, setWaivedTiers] = useState(false)
  useEffect(() => {
    topupService.serviceFeesWaived().then((serviceFeeWaived) => setWaivedTiers(serviceFeeWaived))
  }, [])
  if (!waivedTiers) {
    return null
  }
  return (
    <Card bgColor={theme.colors.greys.lightest} marginBottom={4} noBorder small>
      <Body display="inline" weight="bold" color={theme.colors.tertiary.g_400}>
        <FormattedMessage id="wallet.reward.admin.topup.timeOffer" />
      </Body>
      <Body display="inline" weight="bold" marginLeft={1} color="ink">
        <FormattedMessage id="wallet.reward.admin.topup.serviceFeeOffer" />
      </Body>
    </Card>
  )
}

export default ServiceFeeOfferCard
